import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const ClassesIXtoX = () => {
  useEffect(() => {
    document.title = "Classes IX - X -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Classes IX - X</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="syl">
                {" "}
                Syllabus 2026-2027{" "}
                {/* <span>Syllabus will be updated shortly</span> */}{" "}
              </h1>

              {/* <h5 className="head">    Syllabus 2024-2025</h5> */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h6>Class IX</h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxEng1.pdf"
                    target="_blank"
                  >
                    {" "}
                    English{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxbio.pdf"
                    target="_blank"
                  >
                    {" "}
                    Biology{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxphy.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physics{" "}
                  </Link>
                </li>

                <li>
                  <Link to="#"> Maths </Link>
                </li>
                <li>
                  <Link to="#"> Hindi </Link>
                </li>
                <li>
                  <Link to="#"> Chemistry </Link>
                </li>
                <li>
                  <Link to="#"> History & Political Science </Link>
                </li>
                <li>
                  <Link to="#"> Geography & Economics </Link>
                </li>
                <li>
                  <Link to="#"> Artificial Intelligence </Link>
                </li>

                {/* 
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxmath-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Maths{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxhindi.pdf"
                    target="_blank"
                  >
                    {" "}
                    Hindi{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxche.pdf"
                    target="_blank"
                  >
                    {" "}
                    Chemistry{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxhis.pdf"
                    target="_blank"
                  >
                    {" "}
                    History & Political Science{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxgeo.pdf"
                    target="_blank"
                  >
                    {" "}
                    Geography & Economics{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassIxAI.pdf"
                    target="_blank"
                  >
                    {" "}
                    Artificial Intelligence{" "}
                  </Link>
                </li> */}
              </ul>

              <h6>Class X</h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxeng.pdf"
                    target="_blank"
                  >
                    {" "}
                    English
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxhindi.pdf"
                    target="_blank"
                  >
                    {" "}
                    Hindi
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxmath-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Maths{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxche.pdf"
                    target="_blank"
                  >
                    {" "}
                    Chemistry
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxbio.pdf"
                    target="_blank"
                  >
                    {" "}
                    Biology
                  </Link>
                </li>

                <li>
                  <Link to="#"> Physics</Link>
                </li>
                <li>
                  <Link to="#"> History</Link>
                </li>
                <li>
                  <Link to="#"> Political Science</Link>
                </li>
                <li>
                  <Link to="#"> Geography & Economics</Link>
                </li>
                <li>
                  <Link to="#"> Artificial Intelligence </Link>
                </li>
                {/* 
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxphy.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physics
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxhis.pdf"
                    target="_blank"
                  >
                    {" "}
                    History
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxpoliSci.pdf"
                    target="_blank"
                  >
                    {" "}
                    Political Science
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classxgeo.pdf"
                    target="_blank"
                  >
                    {" "}
                    Geography & Economics
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassxAI.pdf"
                    target="_blank"
                  >
                    {" "}
                    Artificial Intelligence{" "}
                  </Link>
                </li>
               */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassesIXtoX;
